  (function () {
    const BADGE_CLASS = 'aov-subscription-badge';

    const LABELS = {
      fr: {
        subscription: "Abonnement",
        onetime: "Achat unique",
      },
      en: {
        subscription: "Subscription",
        onetime: "One-time purchase",
      }
    };

    function getLanguage() {
      const htmlLang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
      if (htmlLang.startsWith('fr')) return 'fr';
      if (htmlLang.startsWith('en')) return 'en';
      return 'en';
    }

    // Uniquement vrai abonnement : présence de selling_plan_allocation
    function isLineSubscription(line) {
      return !!(line.selling_plan_allocation && line.selling_plan_allocation.selling_plan);
    }

    function updateSubscriptionBadges(cart) {
      if (!cart || !cart.items) return;

      const lang   = getLanguage();
      const labels = LABELS[lang] || LABELS.en;

      const items   = cart.items;
      const lineEls = document.querySelectorAll('.AOV-CartDrawer-Item');
      if (!lineEls.length) return;

      lineEls.forEach((lineEl, index) => {
        const line = items[index];
        if (!line) return;

        // Cas “free gift” Appstle (ex: Kaiju Bottle gratuite) : on ne met pas de badge
        if (line.properties && line.properties._appstle_parent_product) {
          return;
        }

        const titleEl = lineEl.querySelector('.AOV-CartDrawer-ItemName');
        if (!titleEl) return;

        const isSub    = isLineSubscription(line);
        const labelTxt = isSub ? labels.subscription : labels.onetime;

        let badge = titleEl.querySelector('.' + BADGE_CLASS);
        if (!badge) {
          badge = document.createElement('span');
          badge.className = BADGE_CLASS;
          titleEl.appendChild(badge);
        }
        badge.textContent = labelTxt;
      });
    }

    function fetchCartAndUpdateBadges() {
      fetch('/cart.js')
        .then(res => res.json())
        .then(updateSubscriptionBadges)
        .catch(console.error);
    }

    document.addEventListener('DOMContentLoaded', function () {
      // Observe l’apparition / mise à jour du drawer AOV
      const observer = new MutationObserver(() => {
        if (document.querySelector('.AOV-CartDrawer-Item')) {
          fetchCartAndUpdateBadges();
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });

      // Ré-actualiser quand on modifie le panier
      document.body.addEventListener('click', function (e) {
        if (
          e.target.closest('[name="add"]') ||
          e.target.closest('.AOV-CartDrawer-Quantity') ||
          e.target.closest('.AOV-CartDrawer-Remove')
        ) {
          setTimeout(fetchCartAndUpdateBadges, 400);
        }
      });
    });
  })();